import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/** Legacy list URL → same commissions page with Inquiry Batches card active */
function InquiryBatchesPage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/commissions-invoices?report=inquiry_batches", { replace: true });
  }, [navigate]);

  return null;
}

export default InquiryBatchesPage;
